
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteX as ObiOwnShipRemoteXElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-x.js';
 
 
 

 
 export const ObiOwnShipRemoteX = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-x',
   elementClass: ObiOwnShipRemoteXElement,
   events: {
     
   }
  });
 
 